import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../core/utils';

// Example of creating multiple base APIs
export const annotationToolApiV1 = createApi({
  reducerPath: 'annotationToolApiV1',
  baseQuery: createBaseQuery({ version: 'v1' }),
  endpoints: () => ({}), // inject endpoints at the feature level
});

export const annotationToolApi = annotationToolApiV1;
